import React, {FunctionComponent} from "react"
import {CheckCircleIcon} from '@heroicons/react/solid'
import {OrganizationIsLeaseplanAndServiceIsAppointment} from "@App/utils/conditionals/combinations";
import {useTranslation} from "react-i18next";
import {Organization, Service} from "@App/types";

export type HintModalProps = {
    text: string
    organisation: Organization
    service: Service
}

export const HintModal: FunctionComponent<HintModalProps> = (props: HintModalProps)  => {

    const {t} = useTranslation()

    return (
        <div className="flex rounded-md bg-primary-500 p-4 mb-4 partnerHint transition-all duration-1000">
            <div className="flex-shrink-0 self-center">
                <CheckCircleIcon className="h-5 w-5 text-white" aria-hidden="true"/>
            </div>
            <div className="ml-3">
                <p className="text-sm font-medium text-white">{props.text}</p>
                {OrganizationIsLeaseplanAndServiceIsAppointment(props.organisation, props.service) && (
                    <p className="text-sm font-medium text-white" dangerouslySetInnerHTML={{__html: t('hint.appointmentText')}}></p>
                )}
            </div>
        </div>
    )
}
